import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceQuery, config, ScreenType } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input() backButtonLink?: string;
  @Input() pageTitle: string;
  @Input() showBalance: boolean = true;
  @Input() showQr: boolean = true;
  @Input() showFooter: boolean = true;

  screenType = ScreenType;
  pointsBalance$: Observable<number | undefined>;

  constructor(
    private balanceQuery: BalanceQuery,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
  }

  gotoWallet() {
    this.router.navigate(['/rewards/wallet']);
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }
}
